// extracted by mini-css-extract-plugin
export default {"dropdown":"popover_dropdown__J9KLY"};